import React from 'react';

const error = () => <span className="badge badge-danger">Could not fetch tasks</span>;

export default error;